import "./tech-hero.css";
import heroImage from "../img/New/techHero_sec.png";

export default function TechHero() {
  return (
    <section className="oglitz-tech-hero">
      <div className="oglitz-tech-hero__container">
        {/* LEFT */}
        <div className="oglitz-tech-hero__content">
          <span className="oglitz-tech-hero__badge">
            Premium Technology Stack
          </span>

          <h1 className="oglitz-tech-hero__title">
            Technologies Powering <span>Scalable Digital Products</span>
          </h1>

          <p className="oglitz-tech-hero__description">
            Oglitz leverages modern, secure, and scalable technologies to build
            high-performance web, mobile, and cloud solutions for startups and
            enterprises.
          </p>

          <div className="oglitz-tech-hero__tags">
            <span>Custom Software</span>
            <span>Mobile Apps</span>
            <span>Cloud & DevOps</span>
          </div>

          <div className="oglitz-tech-hero__actions">
            <a href="/start-project" className="oglitz-btn-primary">
              Start a Project
            </a>

            <a href="/services" className="oglitz-btn-outline">
              View Services →
            </a>
          </div>
        </div>

        {/* RIGHT */}
        <div className="oglitz-tech-hero__media">
          <img
            src={heroImage}
            alt="Oglitz team building scalable digital products using modern technologies"
            width="620"
            height="420"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
}
